import { Autocomplete, AutocompleteProps, createFilterOptions, TextField } from '@mui/material';
import { useCallback } from 'react';
import { TEXTS } from '../../core/texts';
import { KEYBOARD_EDITING_KEYS, MIN_YEAR_EDUCATION_EXPERIENCE } from '../../core/constraints';

interface IProps extends Omit<AutocompleteProps<any, any, any, any>, 'onChange' | 'renderInput' | 'options'> {
  onChange: (year: number) => void;
  value?: number | null;
  variant?: 'standard' | 'outlined' | 'filled',
  label?: string;
  error?: string | null;
}

const currentYear = new Date().getFullYear();
const yearsArr = Array(70).fill(null).map((_, i) => currentYear - i);

const filter = createFilterOptions<number>({ ignoreCase: true, trim: true });

export const YearAutocomplete = ({
                                   value,
                                   onChange,
                                   label = TEXTS.YEAR,
                                   variant = 'standard',
                                   error,
                                   ...props
                                 }: IProps) => {
  const onChangeHandler = useCallback((_: any, value: string) => {
    if(+value > MIN_YEAR_EDUCATION_EXPERIENCE && +value < currentYear) {
      onChange(+value);
    }
  }, [onChange]);
  return (
    <Autocomplete
      id="tags-standard"
      options={yearsArr}
      onChange={onChangeHandler}
      getOptionLabel={(option) => option.toString()}
      value={value}
      disableClearable
      renderInput={(params) => (
        <TextField
          {...params}
          variant={variant}
          label={label}
          error={!!error}
          helperText={error}
          sx={{ minWidth: 120 }}
          onBlur={(e) => onChangeHandler(null, e.target.value)}
          onKeyDown={(e) => {
            if (
              isNaN(+e.nativeEvent.key)
              && !KEYBOARD_EDITING_KEYS.includes(e.nativeEvent.key.toLowerCase())
              && !e.ctrlKey
              && !e.metaKey
            ) {
              e.preventDefault();
            }
          }}
        />
      )}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        const { inputValue } = params;
        // Suggest the creation of a new value
        const isExisting = options.some((option) => +inputValue === +option);
        if (inputValue !== '' && !isExisting && +inputValue > MIN_YEAR_EDUCATION_EXPERIENCE && +inputValue < currentYear) {
          yearsArr.push(+inputValue);
        }
        return filtered;
      }}
      {...props}
    />
  );
};